import React, { useEffect, useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import dayjs from 'dayjs';
import { use } from 'react';

const MaskedDatePicker = (props) => {

  const { handleOnChange, label, name, isDisabled,
    value, errors, codeIsVerified, required, encryptionValidate } = props;

  const [selectedDate, setSelectedDate] = useState("");
  const [open, setOpen] = useState(false);
  const [showDate, setShowDate] = useState(false);

  useEffect(() => {
    if (value) {
      setSelectedDate(dayjs(value));
    }
  }, [value]);

  useEffect(() => {
    if (!encryptionValidate) {
      setShowDate(true);
    }
  }, [encryptionValidate]);

  const handleToggleVisibility = (e) => {
    e.stopPropagation();
    setShowDate((prev) => !prev);
  };

  const handleDateChange = (newValue) => {
    const realDate = newValue.format('YYYY-MM-DD');
    setSelectedDate(newValue);
    // setOpen(false);
    if (newValue.$D !== selectedDate.$D && selectedDate !== "") {
      setOpen(false);
    }
    handleOnChange(name, realDate);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        open={open}
        onClose={() => setOpen(false)}
        value={selectedDate}
        onChange={(newValue) => handleDateChange(newValue)}
        disabled={isDisabled}
        closeOnSelect={false}
        renderInput={(params) => {
          const updatedParams = {
            ...params,
            inputProps: {
              ...params.inputProps,
              value: selectedDate
                ? (showDate ? selectedDate.format('MM/DD/YYYY') : '**/**/****')
                : '',
              readOnly: true,
            },
          };

          return (
            <TextField
              {...updatedParams}
              fullWidth
              label={(label === "" && required )? "Field is required" : label}
              required={required}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "14px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                  fontWeight: 400,
                  color: "#000000",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                  fontWeight: 400,
                  color: "#000000",
                },
                "& .MuiFormHelperText-root": {
                  fontSize: "14px!important",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#555555",
                  color: "#555555",
                  opacity: 0.9,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#333333",
                  opacity: 1,
                },
                 "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
              }}
              name={name}
              InputLabelProps={{ shrink: true }}
              error={errors[name] ? true : false}
              helperText={errors[name] && errors[name]}
              onClick={() => setOpen(true)}
              InputProps={{
                ...updatedParams.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
                      <CalendarTodayIcon />
                    </IconButton>
                    {encryptionValidate && <IconButton onClick={handleToggleVisibility} disabled={!codeIsVerified} edge="end" color="success">
                      {showDate ? <VisibilityOff /> : <Visibility />}
                    </IconButton>}
                  </InputAdornment>
                ),
                sx: {
                  backgroundColor: `${!selectedDate ? "#f0f0f0" : "#ffffff"}`,
                }
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default MaskedDatePicker;
